import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { transparentize } from '../../helpers';

type PaginationButtonProps = { isSelected: boolean };

const BUTTON_DIMENSION = 30;

const buttonStyles = ({ isSelected }: PaginationButtonProps) => [
  css`
    border-radius: ${theme.borderRadius.small};
    height: ${BUTTON_DIMENSION}px;
    margin: ${theme.spacing(0.75)};
    position: relative;
    transition: 100ms all ease-in-out;
    width: ${BUTTON_DIMENSION}px;
    &:hover {
      background: ${theme.colors.neutral10};
    }
    :focus {
      outline: none;
      :before {
        border-radius: ${theme.borderRadius.medium};
        border: 3px solid ${transparentize(0.4, theme.colors.primary50)};
        content: '';
        height: ${BUTTON_DIMENSION + parseInt(theme.borderRadius.medium)}px;
        left: -4px;
        position: absolute;
        top: -4px;
        width: ${BUTTON_DIMENSION + parseInt(theme.borderRadius.medium)}px;
      }
    }
  `,
  isSelected &&
    css`
      outline: 1px solid ${theme.colors.primary50};
      background: ${theme.colors.neutral10};
      font-weight: ${theme.font.weight.semibold};
    `,
];

export const PaginationStyles = {
  paginationButton: (props: PaginationButtonProps) => buttonStyles(props),
};
